export enum validateStateFile {
  CharacterNotAllowed = 'CharacterNotAllowed',
  fileEmpty = 'fileEmpty',
  fileSuccess = 'fileSuccess',
}
